"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Layout;

var _react = _interopRequireWildcard(require("react"));

var _skipNav = require("@rasahq/react-tabula/core/skip-nav");

var _partials = require("../partials");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isClient = typeof window !== 'undefined';
var isDev = process.env.NODE_ENV == 'development';

function Layout(_ref) {
  var _window;

  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["children"]); // TODO: extract this to a hook


  var tabulaConfig = isClient && isDev ? JSON.parse((_window = window) === null || _window === void 0 ? void 0 : _window.localStorage.getItem('tabula')) || {
    debug: false
  } : {};
  var setTabulaConfig = isClient && isDev ? function () {
    return window.localStorage.setItem('tabula', JSON.stringify(tabulaConfig));
  } : function () {
    return undefined;
  };
  (0, _react.useEffect)(function () {
    if (isDev && isClient) {
      document.body.classList.toggle('debug', tabulaConfig.debug);
      document.body.addEventListener('keyup', function (event) {
        if (event.shiftKey == true && event.ctrlKey == true && (event.keyCode || event.which) == 68) {
          tabulaConfig.debug = !tabulaConfig.debug;
          document.body.classList.toggle('debug', tabulaConfig.debug);
          setTabulaConfig();
        }
      });
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_skipNav.SkipNavLink, null), /*#__PURE__*/_react["default"].createElement(_partials.GlobalHeader, null), /*#__PURE__*/_react["default"].createElement(_skipNav.SkipNavContent, null), /*#__PURE__*/_react["default"].createElement("main", restProps, children), /*#__PURE__*/_react["default"].createElement(_partials.GlobalFooter, null));
}